import type * as React from "react";
import { type ReactNode } from "react";
import { ActionIconButton, ActionIconButtonType } from "../../../../../common/components/Button/ActionIconButton";
import DeleteIcon from "@mui/icons-material/Delete";

interface DeleteButtonProps {
  children?: ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

const DeleteButton: React.FC<DeleteButtonProps> = (props) => {
  return (
    <ActionIconButton
      clickableType={ActionIconButtonType.PRIMARY}
      onIconClick={props.onClick}
      icon={<DeleteIcon  />}
      data-test-id={"btn-delete-line-item"}
      disabled={props.disabled}
    />
  );
};

export default DeleteButton;
